module.exports = __webpack_public_path__ + "static/media/signin-img.96cafb54.png";